import { render, staticRenderFns } from "./DraftAnimal.vue?vue&type=template&id=5bd40416&scoped=true"
import script from "./DraftAnimal.vue?vue&type=script&lang=ts"
export * from "./DraftAnimal.vue?vue&type=script&lang=ts"
import style0 from "./DraftAnimal.vue?vue&type=style&index=0&id=5bd40416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd40416",
  null
  
)

export default component.exports